//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "search-time",
  data() {
    return {
    }
  },
  //icon：single/double选填  不填写为single展示
  //sort: ASC/DESC字段
  //text:'搜索栏 显示的字段'
  props:['icon','sort','text'],

}



// WEBPACK FOOTER //
// ./src/components/search-time.vue